import React from 'react';
import classNames from 'classnames/bind';
import styles from './AirPodPackage.scss';

const cx = classNames.bind(styles);
function AirPodPackage({ initModal }) {
  return (
    <div className={cx('AirPodPackage')}>
      <h5 className="title">에어팟 프로 패키지 자세히 알아보기</h5>
      <span className="close" onClick={initModal} />
      <div>
        <h5 className="subTitle">이용안내</h5>
        <ul>
          <li>
            <span>
              닥터뮤지 에어팟 프로 패키지의 유료 이용기간은 365일이며, 이후
              복습기간이 평생 제공됩니다.
            </span>
          </li>
          <li>
            <span>
              닥터뮤지 이용권은 구매한 계정당 최대 5대의 기기에서 이용 가능하며,
              동시에 여러 기기에서 접속할 수 없습니다.
            </span>
          </li>
        </ul>
        <h5 className="subTitle">배송안내</h5>
        <ul>
          <li>
            <span>
              에어팟 프로는 애플 공식 판매점에서 배송되며, 교재와 이지펜은
              닥터뮤지에서 배송됩니다.
            </span>
          </li>
          <li>
            <span>
              실물 상품은 오후 12시 이전 구매 시 당일 출고됩니다. 오후 12시 이후
              구매 시 익일 출고됩니다.
            </span>
          </li>
          <li>
            <span>
              매월 마지막 영업일 구매 시, 배송 상품은 다음 영업일에 출고됩니다.
            </span>
          </li>
          <li>
            <span>
              정확한 상품 수령을 위하여 주소지를 꼭 확인해주시기 바랍니다.
              (해외, 군부대는 배송 안 됨)
            </span>
          </li>
          <li>
            <span>
              배송과 관련된 문의는 닥터뮤지 고객센터를 이용해주시기 바랍니다.
            </span>
          </li>
        </ul>
        <h5 className="subTitle">환불안내</h5>
        <ul>
          <li>
            <span>
              에어팟 프로 패키지는 강의 수강권, 교재, 이지펜, 에어팟 프로가
              결합된 상품으로, 수강권, 교재, 이지펜, 에어팟 프로 각각의 단독
              환불은 불가함을 확인 안내 드립니다.
            </span>
          </li>
          <li>
            <span>
              닥터뮤지 이용권은 최초 결제승인(완료)일로부터 7일 이내(구매일
              포함)에 환불 신청이 가능하며, 이후로는 이용약관 내 환불 규정에
              따라 공제 금액을 제외하고 환불합니다. 환불한 후에는 닥터뮤지
              서비스를 이용할 수 없습니다.
            </span>
          </li>
          <li>
            <span>
              환불 가능 기간에는 시청한 영상 개수에 상관없이 100% 전액 환불이
              가능합니다. 단, 에어팟 프로, 교재, 기기의 개봉씰이 훼손되지 않은
              상태여야하며 반납 절차가 완료된 후 환불을 진행합니다. 발송 및
              반납에 따른 운송비는 회원이 부담합니다.
            </span>
          </li>
          <li>
            <span>
              기타 에어팟 프로 관련 환불 및 A/S는 애플 코리아의 정책을 따릅니다.
            </span>
          </li>
          <li>
            <span>
              이 외 환불 관련 문의는 닥터뮤지 고객센터를 이용해주시기 바랍니다.
            </span>
          </li>
        </ul>
        {/* <h5 className="subTitle">
          이벤트 사은품 안내 (이벤트 운영 기간에만 해당함)
        </h5>
        <ul>
          <li>
            &middot; 신세계 상품권은 구매일로부터 7일 이내 회원 정보에 입력된
            전화번호로 발송됩니다.
          </li>
          <li>
            &middot; 문자 수신거부, MMS 수신불가, 번호 기재 오류 등으로 인한
            미발송건은 재발송되지 않으므로 반드시 확인하시기 바랍니다.
          </li>
          <li>
            &middot; 모바일 교환권 이용 등에 대해서는 문자로 개별 안내드립니다.
          </li>
          <li>
            &middot; 상품권을 수령하신 고객은 상품권 금액을 차감하여 환불 가능
            금액을 계산합니다.
          </li>
        </ul> */}
      </div>
    </div>
  );
}

export default AirPodPackage;
